import { useContext } from "react";
import { RequestLoader, ToastContext } from "../../../../hooks/context";
import {
  useDeleteGRMutation,
  useDownloadGRMutation,
} from "../../../../hooks/api/mutations/useProcurement";
import { getRandomIntInclusive } from "../../../../helpers";

export const useGRExtra = ({ closeModal = () => {} }) => {
  const triggerToast = useContext(ToastContext);
  const { setRequestLoaderProgress } = useContext(RequestLoader);

  const { mutate: deleteGR, isLoading: isDeletingGR } = useDeleteGRMutation();
  const { mutate: downloadGR, isLoading: isDownlaodingGR } =
    useDownloadGRMutation();

  const handleDeleteGR = (GRDetails) => {
    deleteGR(
      { id: GRDetails?.id },
      {
        onSuccess: () => {
          triggerToast(
            `GRN with No.: ${GRDetails?.gr_number} deleted successfully`,
            "success",
          );
          closeModal();
        },
      },
    );
  };

  const handleDownloadGR = (GRDetails) => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 30));
    downloadGR(
      { id: GRDetails?.id },
      {
        onSuccess: (res) => {
          window.open(res?.data?.data?.url);
          triggerToast(
            `GRN with No.: ${GRDetails?.gr_number} downloaded successfully`,
            "success",
          );
          closeModal();
        },
        onSettled: () => {
          setRequestLoaderProgress(100);
        },
      },
    );
  };

  return {
    isDeletingGR,
    isDownlaodingGR,
    handleDeleteGR,
    handleDownloadGR,
  };
};
